
import React from 'react';
import { Button } from '@/components/ui/button';
import NameField from './form-fields/NameField';
import EmailField from './form-fields/EmailField';
import PasswordFields from './form-fields/PasswordFields';
import PhoneField from './form-fields/PhoneField';
import AgeField from './form-fields/AgeField';
import EducationField from './form-fields/EducationField';

interface SignupFormProps {
  name: string;
  setName: (name: string) => void;
  email: string;
  setEmail: (email: string) => void;
  password: string;
  setPassword: (password: string) => void;
  confirmPassword: string;
  setConfirmPassword: (password: string) => void;
  age?: number;
  setAge: (age: number | undefined) => void;
  phone: string;
  setPhone: (phone: string) => void;
  educationStatus: string;
  setEducationStatus: (status: string) => void;
  educationOptions: Array<{ value: string, label: string }>;
  errors: {
    name?: string;
    email?: string;
    password?: string;
    confirmPassword?: string;
    age?: string;
    phone?: string;
    educationStatus?: string;
  };
  isLoading: boolean;
  onSubmit: (e: React.FormEvent) => Promise<void>;
}

const SignupForm = ({
  name,
  setName,
  email,
  setEmail,
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  age,
  setAge,
  phone,
  setPhone,
  educationStatus,
  setEducationStatus,
  educationOptions,
  errors,
  isLoading,
  onSubmit
}: SignupFormProps) => {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <NameField 
        name={name} 
        setName={setName} 
        error={errors.name} 
      />

      <EmailField 
        email={email} 
        setEmail={setEmail} 
        error={errors.email} 
      />

      <PasswordFields
        password={password}
        setPassword={setPassword}
        confirmPassword={confirmPassword}
        setConfirmPassword={setConfirmPassword}
        passwordError={errors.password}
        confirmPasswordError={errors.confirmPassword}
      />

      <PhoneField 
        phone={phone} 
        setPhone={setPhone} 
        error={errors.phone} 
      />

      <AgeField 
        age={age} 
        setAge={setAge} 
        error={errors.age} 
      />

      <EducationField
        educationStatus={educationStatus}
        setEducationStatus={setEducationStatus}
        educationOptions={educationOptions}
        error={errors.educationStatus}
      />

      <Button
        type="submit"
        className="w-full bg-brand-blue hover:bg-brand-blue/90 mt-6"
        disabled={isLoading}
      >
        {isLoading ? "Creating Account..." : "Create Account"}
      </Button>
    </form>
  );
};

export default SignupForm;
